import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import CustomLoader from "../common/Loader";
import { getProjectForms } from "../../services/projectService";
import { saveFormSettings, getForms } from "./../../services/formService";
import { toaster } from "../../config";
import * as Icon from 'react-feather';
import CustomTooltip from "../common/CustomTooltip";
import {FormTypes} from "../../constants/FormTypes";

class FormSettings extends Component {

    Forms = []

    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show ? this.props.show : false,
            Widget_ID: 0,
            Form_CustomValidationSP: null,
            Form_ClienstSideRules: [],
            Form_BehaviorOnSave: '',
            Form_RedirectTo: null,
            Form_SaveButton: null,
            Form_CancelButton: null,
            Form_SaveAndContinueButton: null,
            Form_SaveAndContinue_RedirectTo: null,
            loading: true,
            Form_ID: this.props.Form_ID ? this.props.Form_ID : 0,
            Form_Type: null,
            Form_SaveWithoutRequiredFieldsButton: null
        }
        this.handleFormSettingsSave = this.handleFormSettingsSave.bind(this);
        this.handleDefaultButtonSwitch = this.handleDefaultButtonSwitch.bind(this);
    }

    async componentDidMount() {
        let { data: Forms } = await getProjectForms(this.props.Project_ID);
        const { data: allForms } = await getForms();
        this.Forms = Forms.filter((form) => form.Form_ID !== this.state.Form_ID);
        let currentForm = allForms.filter((form) => form.Form_ID == this.state.Form_ID);
        currentForm && this.setState({
            Form_BehaviorOnSave: currentForm[0].Form_BehaviorOnSave ? (currentForm[0].Form_BehaviorOnSave).toString() : '',
            Form_RedirectTo: currentForm[0].Form_RedirectTo || null,
            Form_CustomValidationSP: currentForm[0].Form_CustomValidationSP || null,
            Form_ClienstSideRules : currentForm[0].Form_ClienstSideRules === 'None' ? [] : eval(currentForm[0].Form_ClienstSideRules) || [],
            Form_SaveButton: currentForm[0].Form_SaveButton_disable === 'True' || null,
            Form_CancelButton: currentForm[0].Form_CancelButton_disable === 'True' || null,
            Form_SaveAndContinueButton: currentForm[0].Form_SaveAndContinueButton_disable === 'True' || null,
            Form_SaveAndContinue_RedirectTo: currentForm[0].Form_SaveAndContinue_RedirectTo || null,
            Form_Type: currentForm[0].Form_Type || FormTypes.SingleResponse, // default type is 1 (single response)
            Form_SaveWithoutRequiredFieldsButton: currentForm[0].Form_SaveWithoutRequiredFieldsButton_disable === 'True' || null,
            loading: false
        });
        !currentForm[0].Form_ClienstSideRules && this.handleAddColumn(0)
    }

    handleClose = (name) => {
        this.setState({ [name]: false });
    };

    handleFormSettingsChange(target) {
        this.setState({ [target.name]: target.value })
    }

    async handleFormSettingsSave() {
        let { data } = await saveFormSettings(this.state);
        if (data.includes('Success')) {
            toaster('success', 'Form Settings Saved')
            this.setState({ show: false })
        }
        else {
            toaster('error', 'Form Settings Save failed')
        }
    }

    handleAddColumn() {
        const Form_ClienstSideRules = [...this.state.Form_ClienstSideRules, { 'Rule_ID': this.state.Form_ClienstSideRules.length, 'Rule_Text': '' }];
        this.setState({ Form_ClienstSideRules });
    }

    handleRemoveColumn(idx) {
        let Form_ClienstSideRules = this.state.Form_ClienstSideRules.filter(function (col, index) {
            return index !== idx;
        });
        Form_ClienstSideRules.map((rule, idx) => {
            rule['Rule_ID'] = idx
        })
        this.setState({ Form_ClienstSideRules });
    }

    handleChange = (input, idx) => {
        this.setState({ [input.name]: input.value });
        let Form_ClienstSideRules = this.state.Form_ClienstSideRules
        Form_ClienstSideRules.map((rule) => {
            if (rule['Rule_ID'] === idx) {
                rule['Rule_Text'] = input.value
            }
        })
        this.setState({ Form_ClienstSideRules })
    };

    handleDefaultButtonSwitch = (target) => {
        this.setState({ [target.name]: !this.state[target.name] });
    };

    render() {
        const { Form_SaveButton, Form_CancelButton, Form_SaveAndContinueButton, Form_SaveWithoutRequiredFieldsButton } = this.state;
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }
        return (
            <React.Fragment>
                <Modal size='lg' show={this.state.show} onHide={() => this.handleClose("show")}>
                    <Modal.Header className="card-header font-weight-bold text-primary" closeButton>
                        Form Settings
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="form-group">
                                <label>Disable Default Buttons</label>
                                <div className="custom-control custom-switch">
                                    <input type="checkbox" id="id_Form_SaveButton" name="Form_SaveButton" className="custom-control-input" checked={Form_SaveButton} value={Form_SaveButton} onChange={(e) => this.handleDefaultButtonSwitch(e.target)} />
                                    <label id="label_Form_SaveButton" name="labelId_SaveButton" htmlFor="id_Form_SaveButton" className="custom-control-label">Save</label>
                                    <span>
                                        <input type="checkbox" id="id_Form_CancelButton" name="Form_CancelButton" className="custom-control-input" checked={Form_CancelButton} value={Form_CancelButton} onChange={(e) => this.handleDefaultButtonSwitch(e.target)} />
                                        <label id="label_Form_CancelButton" name="labelId_CancelButton" htmlFor="id_Form_CancelButton" className="custom-control-label ml-10">Cancel</label>
                                    </span>
                                    <span>
                                        <input
                                            type="checkbox"
                                            id="id_Form_SaveAndContinueButton"
                                            name="Form_SaveAndContinueButton"
                                            className="custom-control-input"
                                            checked={Form_SaveAndContinueButton}
                                            value={Form_SaveAndContinueButton}
                                            onChange={(e) => this.handleDefaultButtonSwitch(e.target)}
                                        />
                                        <label
                                            id="label_Form_SaveAndContinueButton"
                                            name="labelId_SaveAndContinueButton"
                                            htmlFor="id_Form_SaveAndContinueButton"
                                            className="custom-control-label ml-10"
                                        >
                                            Save and Continue
                                        </label>
                                    </span>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="Form_Type">Form Type</label>
                                <select
                                    className="form-control"
                                    id="Form_Type"
                                    name="Form_Type"
                                    value={this.state.Form_Type}
                                    onChange={(e) => this.handleFormSettingsChange(e.target)}
                                >
                                    <option key='1' value={FormTypes.SingleResponse}>Single Response</option>
                                    <option key='2' value={FormTypes.MultipleResponse}>Multiple Response</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="Form_BehaviorOnSave">Save Action</label>
                                <select
                                    type="text"
                                    className="form-control"
                                    id="Form_BehaviorOnSave"
                                    name="Form_BehaviorOnSave"
                                    value={this.state.Form_BehaviorOnSave}
                                    onChange={(e) => this.handleFormSettingsChange(e.target)}
                                >
                                    <option key='0' value={0}>- Select -</option>
                                    <option key='2' value={2}>Clear Form</option>
                                    <option key='1' value={1}>Redirect Form</option>
                                    <option key='3' value={3}>Reload Page</option>
                                </select>
                            </div>
                            {(this.state.Form_BehaviorOnSave).includes('1') &&
                                <div className="form-group">
                                    <label htmlFor="Form_RedirectTo">Redirect To</label>
                                    <select
                                        id="Form_RedirectTo"
                                        className="form-control"
                                        name='Form_RedirectTo'
                                        value={this.state.Form_RedirectTo}
                                        onChange={(e) => this.handleFormSettingsChange(e.target)}
                                    >
                                        <option key='-1'>- Select -</option>
                                        {this.Forms.map((form) => {
                                            return (
                                                <option key={form.Form_ID} value={form.Form_ID}>
                                                    {form.Form_Name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            }
                            {!this.state.Form_SaveAndContinueButton &&
                                <div className="form-group">
                                    <label htmlFor="Form_SaveAndContinue_RedirectTo">Save and Continue Redirect To</label>
                                    <CustomTooltip
                                        title="Select only a form that is in the tabs list of the main outer form"
                                        placement='right'
                                        className="text-muted pl-1 d-inline"
                                    >
										<Icon.Info size={20} />
									</CustomTooltip>
                                    <select
                                        id="Form_SaveAndContinue_RedirectTo"
                                        className="form-control"
                                        name='Form_SaveAndContinue_RedirectTo'
                                        value={this.state.Form_SaveAndContinue_RedirectTo}
                                        onChange={(e) => this.handleFormSettingsChange(e.target)}
                                    >
                                        <option key='-1'>- Select -</option>
                                        {this.Forms.map((form) => {
                                            return (
                                                <option key={form.Form_ID} value={form.Form_ID}>
                                                    {form.Form_Name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            }
                            <div className="form-group">
                                <label htmlFor="Form_CustomValidationSP">Custom Server Side Validation</label>
                                <CustomTooltip
                                    title="A response of 0 is considered valid and allow to save, while any other value is invalid."
                                    placement='right'
                                    className="text-muted pl-1 d-inline"
                                >
                                    <Icon.Info size={20} />
                                </CustomTooltip>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="Form_CustomValidationSP"
                                    name="Form_CustomValidationSP"
                                    placeholder="Enter Stored Procedure Name"
                                    value={this.state.Form_CustomValidationSP}
                                    onChange={(e) => this.handleFormSettingsChange(e.target)}
                                />
                            </div>
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <span>
                                        <input
                                            type="checkbox"
                                            id="id_Form_SaveWithoutRequiredFieldsButton"
                                            name="Form_SaveWithoutRequiredFieldsButton"
                                            className="custom-control-input"
                                            checked={Form_SaveWithoutRequiredFieldsButton}
                                            value={Form_SaveWithoutRequiredFieldsButton}
                                            onChange={(e) => this.handleDefaultButtonSwitch(e.target)}
                                        />
                                        <label
                                            id="label_Form_SaveWithoutRequiredFieldsButton"
                                            name="labelId_SaveWithoutRequiredFieldsButton"
                                            htmlFor="id_Form_SaveWithoutRequiredFieldsButton"
                                            className="custom-control-label"
                                        >
                                            Prevent saving if required fields are not filled
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={this.handleFormSettingsSave}>
                            Save
                        </button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FormSettings;